// import React, { useEffect, useState } from "react";
// import pic from "../../Assets/ContentCreation.jpg";

// const Section2 = () => {
//   const [scrollPosition, setScrollPosition] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrollPosition(window.pageYOffset);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div className="relative h-[70vh] w-full overflow-hidden">
//       {/* Background Image with contained movement */}
//       <div
//         className="absolute inset-0 w-full h-[120%]"
//         style={{
//           backgroundImage: `url(${pic})`,
//           backgroundPosition: "center",
//           backgroundSize: "cover",
//           filter: "brightness(0.8)",
//           top: `-10%`,
//           transform: `translateY(${Math.min(
//             Math.max(scrollPosition * 0.1, 0),
//             20
//           )}px)`,
//         }}
//       />

//       {/* Content Container */}
//       <div className="relative h-full flex items-center justify-center bg-black/30">
//         <div className="container mx-auto px-4 flex justify-center items-center text-white gap-16">
//           {/* Left Section - Positioned slightly higher */}
//           <div className="w-64 -translate-y-16">
//             {" "}
//             {/* Fixed width and shifted up */}
//             <h2 className="text-sm mb-1 uppercase tracking-widest font-semibold">
//               Our Clients Are
//             </h2>
//             <h3
//               className="text-5xl italic mb-6 font-light"
//               style={{
//                 fontFamily: "Blacker Pro Display",
//               }}
//             >
//               all about
//             </h3>
//             <p
//               className="text-md leading-relaxed text-justify font-light"
//               style={{
//                 fontFamily: "commuterssans-regular",
//               }}
//             >
//               Collaboration, bold ideas, and a commitment to excellence. We
//               thrive when working with clients who share these values.
//             </p>
//           </div>

//           {/* Divider Line - More curved and angled */}
//           <div
//             className="h-64 w-px bg-white mx-6 relative"
//             style={{
//               transform: "rotate(25deg)", // More pronounced angle
//               background:
//                 "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(255,255,255,0) 100%)",
//             }}
//           />

//           {/* Right Section */}
//           <div className="w-64 translate-y-12 ">
//             {" "}
//             {/* Fixed width */}
//             <h3
//               className="text-5xl italic mb-6 font-light "
//               style={{
//                 fontFamily: "Blacker Pro Display",
//               }}
//             >
//               not about
//             </h3>
//             <p
//               className="text-md leading-relaxed text-justify font-light"
//               style={{
//                 fontFamily: "commuterssans-regular",
//               }}
//             >
//               Quick fixes, one-size-fits-all solutions, or lack of engagement.
//               If these are your priorities, we might not be a match—but we can
//               recommend someone else.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section2;
import React, { useEffect, useState } from "react";
import pic from "../../Assets/ContentCreation.jpg";

const Section2 = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="relative h-[100vh] md:h-[70vh] w-full overflow-hidden">
      {/* Background Image with contained movement */}
      <div
        className="absolute inset-0 w-full h-[120%]"
        style={{
          backgroundImage: `url(${pic})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          filter: "brightness(0.8)",
          top: `-10%`,
          transform: `translateY(${Math.min(
            Math.max(scrollPosition * 0.1, 0),
            20
          )}px)`,
        }}
      />

      {/* Content Container */}
      <div className="relative h-full flex items-center justify-center bg-black/30">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-center items-center text-white md:gap-16">
          {/* Left Section */}
          <div className="w-full max-w-[300px] md:w-64 mb-8 md:mb-0 md:-translate-y-16 text-center md:text-left">
            <h2 className="text-sm mb-1 uppercase tracking-widest font-semibold">
              Our Clients Are
            </h2>
            <h3
              className="text-4xl md:text-5xl italic mb-4 md:mb-6 font-light"
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              all about
            </h3>
            <p
              className="text-sm md:text-md leading-relaxed text-center md:text-justify font-light px-4 md:px-0"
              style={{
                fontFamily: "commuterssans-regular",
              }}
            >
              Collaboration, bold ideas, and a commitment to excellence. We
              thrive when working with clients who share these values.
            </p>
          </div>

          {/* Divider Line - Hidden on mobile, visible on desktop */}
          <div
            className="hidden md:block h-64 w-px bg-white mx-6 relative"
            style={{
              transform: "rotate(25deg)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(255,255,255,0) 100%)",
            }}
          />

          {/* Mobile Divider */}
          <div
            className="w-24 h-px bg-white my-8 md:hidden"
            style={{
              background:
                "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(255,255,255,0) 100%)",
            }}
          />

          {/* Right Section */}
          <div className="w-full max-w-[300px] md:w-64 md:translate-y-12 text-center md:text-left">
            <h3
              className="text-4xl md:text-5xl italic mb-4 md:mb-6 font-light"
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              not about
            </h3>
            <p
              className="text-sm md:text-md leading-relaxed text-center md:text-justify font-light px-4 md:px-0"
              style={{
                fontFamily: "commuterssans-regular",
              }}
            >
              Quick fixes, one-size-fits-all solutions, or lack of engagement.
              If these are your priorities, we might not be a match—but we can
              recommend someone else.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
